import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ReceiptsListPage } from './ReceiptsListPage';

const searchSchema = z.object({
  receiptId: z.string().optional(),
  userId: z.string().optional(),
  loyaltyProgramId: z.string().optional(),
  merchantQuery: z.string().optional(),
  filename: z.string().optional(),
  contentType: z.string().optional(),
  transactionDateAfter: z.string().optional(),
  transactionDateBefore: z.string().optional(),
  createdAfter: z.coerce.date().optional(),
  createdBefore: z.coerce.date().optional(),
  statuses: z.array(z.string()).optional(),
  rejectedReasons: z.array(z.string()).optional(),
  reviewStatuses: z.array(z.string()).optional(),
  reviewIssueTypes: z.array(z.string()).optional(),
  amountMin: z.string().optional(),
  amountMax: z.string().optional(),
  benefitMin: z.string().optional(),
  benefitMax: z.string().optional(),
  sortBy: z.enum(['transaction_date', 'created_at', 'amount']).optional().default('created_at'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
  cursor: z.string().optional(),
  limit: z.coerce.number().positive().int().max(100).optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/receipts/')({
  component: ReceiptsListPage,
  validateSearch: searchSchema,
});
